# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class AboutMenu extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'AboutMenuModule'
#
#   @selector: ".about_menu_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# AboutMenu.register()
